var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstCommissioning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.93 17.91C41.45 17.73 41.2 17.19 41.39 16.7C41.58 16.21 42.11 15.97 42.6 16.16L47.97 18.19L47.31 19.94L41.94 17.91H41.93Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.99 12.4501C43.51 12.2701 43.26 11.7301 43.45 11.2401C43.64 10.7501 44.17 10.5101 44.66 10.7001L50.03 12.7301L49.37 14.4801L44 12.4501H43.99Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1 10.48L45.87 21.67C45.31 23.15 46.32 24.76 47.91 24.89C51.49 25.19 55.37 27.2 58.17 23.28C59.66 23.54 61.18 24.05 62.15 21.5C63.12 18.95 61.61 18.19 60.31 17.35C60.6 12.78 56.58 11.5 53.77 9.40003C52.5 8.45003 50.67 8.99003 50.11 10.47L50.1 10.48Z",
    fill: "#5A87FF",
    stroke: "#5A87FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.63 21.52C78 27.19 88.3 41.49 88.4 57.88C88.46 67.74 81.18 76.3 71.35 77.07C65.42 77.54 59.25 75.13 56.03 65.1",
    stroke: "#5A87FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.02 51.59H16.48C13.7848 51.59 11.6 53.7748 11.6 56.47V86.18C11.6 88.8751 13.7848 91.06 16.48 91.06H63.02C65.7151 91.06 67.9 88.8751 67.9 86.18V56.47C67.9 53.7748 65.7151 51.59 63.02 51.59Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 49.16V41.29C22.46 38.42 24.81 36.08 27.67 36.08H51.83C54.7 36.08 57.04 38.43 57.04 41.29V49.16",
    stroke: "#E0BF53",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 57.92V51.09C11.6 48.39 13.79 46.21 16.48 46.21H63.02C65.72 46.21 67.9 48.4 67.9 51.09V57.92H11.6Z",
    fill: "#E0BF53",
    stroke: "#E0BF53",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.94 87.1399C46.4625 87.1399 51.75 81.8524 51.75 75.3299C51.75 68.8074 46.4625 63.5199 39.94 63.5199C33.4175 63.5199 28.13 68.8074 28.13 75.3299C28.13 81.8524 33.4175 87.1399 39.94 87.1399Z",
    fill: "#E0BF53",
    stroke: "#E0BF53",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 78.8099C47.85 77.0699 48.45 74.6099 47.91 72.3799L43.95 76.3399L39.63 75.6399L38.93 71.3199L42.89 67.3599C40.66 66.8199 38.2 67.4199 36.46 69.1599C34.72 70.8999 34.08 73.5099 34.71 75.8099L31.77 78.7499L36.53 83.5099L39.47 80.5699C41.76 81.1999 44.32 80.6199 46.12 78.8199L46.11 78.8099Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstCommissioning);
export default __webpack_public_path__ + "static/media/first-commissioning.5fa4186a3eb08fecd9923f010c5d32fe.svg";
export { ForwardRef as ReactComponent };